import styled from 'styled-components';

import { Button, BUTTON_VARIANTS } from 'ui/button';
import { AiSparkle16 } from 'ui/icons';
import { PopoverTrigger } from 'ui/popover';
import { body2, colors, spacing } from 'ui/theme';
import { NoOp } from 'utils/noop';

import { useTranslation } from '../../hooks';

const AIButtonLabel = styled.span`
  ${body2}
  color: ${colors.textInteractive};
  text-align: left;
`;

const StyledButton = styled(Button)`
  align-items: flex-start;
  height: auto;
  margin-bottom: ${spacing.quarter};
  padding-top: 7px;
  padding-bottom: 7px;
  max-width: 80ch;
  padding-left: 0;
  &::before {
    border-width: 0px;
  }
  svg {
    flex-shrink: 0;
  }
  :focus-visible {
    outline: ${spacing.single} solid ${colors.borderInteractive};
    background-color: ${colors.grey5};
  }
  :focus-visible,
  :hover {
    padding-left: ${spacing.threeQuarter};
    margin-left: ${spacing.single};
  }
`;

export const testIds = {
  emptyTrigger: 'list-description-empty-trigger',
};

export const ListDescriptionAIEmptyTrigger = ({ onClick }: { onClick: NoOp }) => {
  const { t } = useTranslation();

  return (
    <PopoverTrigger asChild>
      <StyledButton
        data-test={testIds.emptyTrigger}
        onClick={onClick}
        type="button"
        variant={BUTTON_VARIANTS.GHOST}
      >
        <AIButtonLabel>{t('header.emptyDescription')}</AIButtonLabel>
        <AiSparkle16 />
      </StyledButton>
    </PopoverTrigger>
  );
};
